import { render, staticRenderFns } from "./StepFinish.vue?vue&type=template&id=a38a81f2&scoped=true&"
import script from "./StepFinish.vue?vue&type=script&lang=js&"
export * from "./StepFinish.vue?vue&type=script&lang=js&"
import style0 from "./StepFinish.vue?vue&type=style&index=0&id=a38a81f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a38a81f2",
  null
  
)

export default component.exports